import React, { useMemo } from "react";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import Button from "@mui/material/Button";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import * as XLSX from "xlsx";
import { useTranslation } from "react-i18next";
import { useUserContext } from "context/UserContext";

const API_URL = "https://crm-mqtt-718408119422.asia-east1.run.app/api/v1/order/currency_list";
const API_KEY = "57b2a9ba-4428-48e4-b137-f8337b68595e";
const APPSMITH_TRANSACTIONS_URL =
  "https://app.appsmith.com/app/transaction/page1-6879b062263c1d7f9e7c7e7f?embed=true&hide_navigation_bar=true";

function TransactionsCM() {
  const { t } = useTranslation("common");
  const { userData } = useUserContext() || {};
  const iframeUrl = useMemo(() => {
    const email = userData?.email?.trim();
    const url = new URL(APPSMITH_TRANSACTIONS_URL);
    if (email) {
      url.searchParams.set("email", email);
    }
    url.searchParams.set("role", "CM");
    return url.toString();
  }, [userData?.email]);
  const downloadExcel = async () => {
    try {
      const res = await fetch(API_URL, {
        method: "POST",
        headers: {
          "Mdm-Auth": API_KEY,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          page: 0,
          size: 1000,
          showDetail: true,
        }),
      });

      const json = await res.json();

      const orders = Array.isArray(json.data)
        ? json.data
        : Array.isArray(json.data?.orders)
        ? json.data.orders
        : [];

      if (!orders.length) {
        alert("API 無資料");
        return;
      }

      const headers = [
        "order_status",
        "order_id",
        "order_type",
        "user_phone",
        "user_email",
        "store_id",
        "store_name",
        "order_description",
        "order_amount",
        "paid_amount",
        "redeem_points",
        "discount_amount",
        "coupon",
        "channel",
        "invoice_carrier",
        "note",
        "created_at",
        "extra_data",
        "invoice_number",
        "invoice_issued_at",
        "payment_method",
        "payment_id",
        "sku",
        "product_name_full",
        "quantity",
        "warehouse_code",
        "company_tax_id",
        "love_code",
        "invoice_email",
        "carrier_type",
        "product_name",
        "specification",
        "vendor_code",
        "vendor_name",
        "brand",
        "movie_or_portrait",
        "nature",
        "product_series",
        "purchase_category",
        "package_size",
        "capsule_size",
        "valid_until",
        "product_attributes",
        "product_brand",
        "work_attributes",
        "tags",
        "venue_name",
        "venue_distribution",
        "venue_type",
        "venue_tags",
        "flow_level",
        "machine_location",
        "landmark_nearby",
        "machine_count",
        "machine_type",
        "target_customers",
        "gacha_deviceId",
      ];

      const rows = orders.map((item) =>
        headers.map((key) => {
          if (key === "extra_data" && item[key] && typeof item[key] === "object") {
            return JSON.stringify(item[key]);
          }
          return item[key] !== undefined ? item[key] : "";
        })
      );

      const sheetData = [headers, ...rows];
      const worksheet = XLSX.utils.aoa_to_sheet(sheetData);
      const range = XLSX.utils.decode_range(worksheet["!ref"]);

      for (let row = 1; row <= range.e.r; row += 1) {
        const orderIdCell = worksheet[XLSX.utils.encode_cell({ r: row, c: 1 })];
        const phoneCell = worksheet[XLSX.utils.encode_cell({ r: row, c: 3 })];
        if (orderIdCell) orderIdCell.t = "s";
        if (phoneCell) phoneCell.t = "s";
      }

      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Transactions");
      XLSX.writeFile(workbook, "transactions.xlsx");
    } catch (err) {
      console.error(err);
      alert("下載失敗");
    }
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox pt={6} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Card>
              <MDBox
                mx={2}
                mt={-3}
                py={3}
                px={2}
                variant="gradient"
                bgColor="info"
                borderRadius="lg"
                coloredShadow="info"
                display="flex"
                justifyContent="space-between"
                alignItems="center"
              >
                <MDTypography variant="h6" color="white">
                  {t("pageTitles.transactions")}
                </MDTypography>
                {/* <Button
                  variant="contained"
                  color="secondary"
                  onClick={downloadExcel}
                  sx={{
                    backgroundColor: "#FF9800",
                    color: "#FFFFFF",
                    "&:hover": { backgroundColor: "#FB8C00" },
                  }}
                >
                  {t("actions.exportTransactions")}
                </Button> */}
              </MDBox>
              <MDBox pt={3} px={0} width="100%">
                <iframe
                  src={iframeUrl}
                  width="100%"
                  height="800px"
                  frameBorder="0"
                  title="Appsmith Transactions"
                />
              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
    </DashboardLayout>
  );
}

export default TransactionsCM;
